module.exports = __webpack_public_path__ + "static/media/WiLine-Logo@200w_72ppi.b2ebaf56.webp";